import { render, staticRenderFns } from "./Kitchen.vue?vue&type=template&id=62240452&"
import script from "./Kitchen.vue?vue&type=script&lang=js&"
export * from "./Kitchen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports